import { Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import type { OptionAction, OptionData, RestockButton } from '../../../../type/common.type';

interface Props {
  option: OptionData;
  restock_button: RestockButton;
  action?: OptionAction;
}

export const RestockAlertButton = ({ option, restock_button, action }: Props) => {
  return (
    <Container
      onClick={(e) => {
        e.stopPropagation();
        action?.handleRestockNotification?.(option);
      }}
    >
      {restock_button.button_type === 'notification' && (
        <NotificationButton>
          <Text variant='Caption_12_SemiBold' v3Color='gray700'>
            {restock_button.active ? '알림 취소' : '재입고 알림'}
          </Text>
        </NotificationButton>
      )}
      {restock_button.button_type === 'view_more' && (
        <Text
          variant='Caption_12_SemiBold'
          v3Color='gray700'
          style={{
            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center',
            height: '100%',
            textDecoration: 'underline',
            textDecorationColor: vars.v3Color.gray300,
          }}
        >
          재입고 알림
        </Text>
      )}
    </Container>
  );
};

const Container = styled.div`
  min-width: 82px;
  text-align: right;
  cursor: pointer;
`;

const NotificationButton = styled.button`
  padding: 7px 12px;
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  border-radius: 32px;
  border: 1px solid ${vars.v3Color.gray100};
  background-color: ${vars.v3Color.white};
  z-index: 5;
  cursor: pointer;
`;
